// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js!../_base.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js!../../ui/styles/tavern-components.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.games-page {
  padding: var(--space-4);
  max-width: 960px;
  margin: 0 auto;
}

.games-page__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-4);
  margin-bottom: var(--space-4);
}

.games-page__title {
  font-family: var(--font-heading);
  font-size: var(--font-size-h1);
  font-weight: var(--font-weight-bold);
  color: var(--color-fire-600);
  margin: 0;
  display: flex;
  align-items: center;
  gap: var(--space-2);
}

.games-page__add-btn {
  white-space: nowrap;
  background: var(--color-fire-600);
  color: var(--color-parchment-100);
  border: 2px solid var(--color-fire-700);
  padding: var(--space-2) var(--space-4);
  border-radius: var(--radius-md);
  font-family: var(--font-heading);
  font-weight: 700;
  font-size: var(--font-size-body);
  cursor: pointer;
  transition: all var(--transition-fast);
  box-shadow: var(--shadow-button);
}

.games-page__add-btn:hover {
  background: var(--color-fire-500);
  transform: translateY(-1px);
  box-shadow: var(--shadow-md);
}

.games-page__add-btn:active {
  transform: translateY(0);
}

/* Filters area */
.games-page__filters {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  margin-bottom: var(--space-4);
}

.games-page__search {
  position: relative;
}

.games-page__search-input {
  width: 100%;
  padding: var(--space-3) var(--space-4);
  padding-right: 40px;
  border: 2px solid var(--color-wood-600);
  border-radius: var(--radius-lg);
  font-family: var(--font-body);
  font-size: var(--font-size-body);
  background: var(--color-parchment-100);
  color: var(--color-text-primary);
  outline: none;
  transition: border-color var(--transition-fast), box-shadow var(--transition-fast);
  box-sizing: border-box;
}

.games-page__search-input::placeholder {
  color: var(--color-text-tertiary);
}

.games-page__search-input:focus {
  border-color: var(--color-fire-500);
  box-shadow: 0 0 0 3px rgba(216, 90, 31, 0.15);
}

.games-page__search-clear {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  font-size: 20px;
  color: var(--color-text-secondary);
  cursor: pointer;
  padding: 4px;
  line-height: 1;
  transition: color var(--transition-fast);
}

.games-page__search-clear:hover {
  color: var(--color-fire-600);
}

.games-page__filter-row {
  display: flex;
  gap: var(--space-2);
}

/* Favorites button on dark background */
.games-page__filter-row .game-tag--filter {
  border: 2px solid var(--color-wood-600);
  background: var(--color-wood-700);
  color: var(--color-parchment-200);
  font-weight: var(--font-weight-semibold);
}

.games-page__filter-row .game-tag--filter:hover {
  background: var(--color-wood-600);
  border-color: var(--color-fire-500);
  color: var(--color-parchment-100);
}

.games-page__filter-row .game-tag--active {
  background: var(--color-fire-500);
  border-color: var(--color-fire-600);
  color: var(--color-parchment-100);
}

.games-page__filter-row .game-tag--active:hover {
  background: var(--color-fire-600);
  border-color: var(--color-fire-700);
}

/* Content area */
.games-page__content {
  min-height: 200px;
}

/* Empty state adapted for dark background */
.games-page__content .tavern-empty-state-title {
  color: var(--color-parchment-200);
}

.games-page__content .tavern-empty-state-description {
  color: var(--color-parchment-300);
}

@media (min-width: 1024px) {
  .games-page {
    max-width: var(--content-max);
    padding: var(--space-6) var(--space-7);
  }
}

@media (max-width: 425px) {
  .games-page {
    padding: var(--space-3);
  }

  .games-page__title {
    font-size: var(--font-size-h3);
  }

  .games-page__add-btn {
    padding: var(--space-2) var(--space-3);
    font-size: var(--font-size-body-sm);
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Games/GamesPage.css"],"names":[],"mappings":"AAGA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;EAC9B,oCAAoC;EACpC,4BAA4B;EAC5B,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,iCAAiC;EACjC,iCAAiC;EACjC,uCAAuC;EACvC,sCAAsC;EACtC,+BAA+B;EAC/B,gCAAgC;EAChC,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,sCAAsC;EACtC,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,sCAAsC;EACtC,mBAAmB;EACnB,uCAAuC;EACvC,+BAA+B;EAC/B,6BAA6B;EAC7B,gCAAgC;EAChC,sCAAsC;EACtC,gCAAgC;EAChC,aAAa;EACb,kFAAkF;EAClF,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,mCAAmC;EACnC,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kCAAkC;EAClC,eAAe;EACf,YAAY;EACZ,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,wCAAwC;AACxC;EACE,uCAAuC;EACvC,iCAAiC;EACjC,iCAAiC;EACjC,wCAAwC;AAC1C;;AAEA;EACE,iCAAiC;EACjC,mCAAmC;EACnC,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;EACjC,mCAAmC;EACnC,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;EACjC,mCAAmC;AACrC;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;AACnB;;AAEA,4CAA4C;AAC5C;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE;IACE,6BAA6B;IAC7B,sCAAsC;EACxC;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,sCAAsC;IACtC,mCAAmC;EACrC;AACF","sourcesContent":["@import '../_base.css';\n@import '../../ui/styles/tavern-components.css';\n\n.games-page {\n  padding: var(--space-4);\n  max-width: 960px;\n  margin: 0 auto;\n}\n\n.games-page__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--space-4);\n  margin-bottom: var(--space-4);\n}\n\n.games-page__title {\n  font-family: var(--font-heading);\n  font-size: var(--font-size-h1);\n  font-weight: var(--font-weight-bold);\n  color: var(--color-fire-600);\n  margin: 0;\n  display: flex;\n  align-items: center;\n  gap: var(--space-2);\n}\n\n.games-page__add-btn {\n  white-space: nowrap;\n  background: var(--color-fire-600);\n  color: var(--color-parchment-100);\n  border: 2px solid var(--color-fire-700);\n  padding: var(--space-2) var(--space-4);\n  border-radius: var(--radius-md);\n  font-family: var(--font-heading);\n  font-weight: 700;\n  font-size: var(--font-size-body);\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  box-shadow: var(--shadow-button);\n}\n\n.games-page__add-btn:hover {\n  background: var(--color-fire-500);\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-md);\n}\n\n.games-page__add-btn:active {\n  transform: translateY(0);\n}\n\n/* Filters area */\n.games-page__filters {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-3);\n  margin-bottom: var(--space-4);\n}\n\n.games-page__search {\n  position: relative;\n}\n\n.games-page__search-input {\n  width: 100%;\n  padding: var(--space-3) var(--space-4);\n  padding-right: 40px;\n  border: 2px solid var(--color-wood-600);\n  border-radius: var(--radius-lg);\n  font-family: var(--font-body);\n  font-size: var(--font-size-body);\n  background: var(--color-parchment-100);\n  color: var(--color-text-primary);\n  outline: none;\n  transition: border-color var(--transition-fast), box-shadow var(--transition-fast);\n  box-sizing: border-box;\n}\n\n.games-page__search-input::placeholder {\n  color: var(--color-text-tertiary);\n}\n\n.games-page__search-input:focus {\n  border-color: var(--color-fire-500);\n  box-shadow: 0 0 0 3px rgba(216, 90, 31, 0.15);\n}\n\n.games-page__search-clear {\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  font-size: 20px;\n  color: var(--color-text-secondary);\n  cursor: pointer;\n  padding: 4px;\n  line-height: 1;\n  transition: color var(--transition-fast);\n}\n\n.games-page__search-clear:hover {\n  color: var(--color-fire-600);\n}\n\n.games-page__filter-row {\n  display: flex;\n  gap: var(--space-2);\n}\n\n/* Favorites button on dark background */\n.games-page__filter-row .game-tag--filter {\n  border: 2px solid var(--color-wood-600);\n  background: var(--color-wood-700);\n  color: var(--color-parchment-200);\n  font-weight: var(--font-weight-semibold);\n}\n\n.games-page__filter-row .game-tag--filter:hover {\n  background: var(--color-wood-600);\n  border-color: var(--color-fire-500);\n  color: var(--color-parchment-100);\n}\n\n.games-page__filter-row .game-tag--active {\n  background: var(--color-fire-500);\n  border-color: var(--color-fire-600);\n  color: var(--color-parchment-100);\n}\n\n.games-page__filter-row .game-tag--active:hover {\n  background: var(--color-fire-600);\n  border-color: var(--color-fire-700);\n}\n\n/* Content area */\n.games-page__content {\n  min-height: 200px;\n}\n\n/* Empty state adapted for dark background */\n.games-page__content .tavern-empty-state-title {\n  color: var(--color-parchment-200);\n}\n\n.games-page__content .tavern-empty-state-description {\n  color: var(--color-parchment-300);\n}\n\n@media (min-width: 1024px) {\n  .games-page {\n    max-width: var(--content-max);\n    padding: var(--space-6) var(--space-7);\n  }\n}\n\n@media (max-width: 425px) {\n  .games-page {\n    padding: var(--space-3);\n  }\n\n  .games-page__title {\n    font-size: var(--font-size-h3);\n  }\n\n  .games-page__add-btn {\n    padding: var(--space-2) var(--space-3);\n    font-size: var(--font-size-body-sm);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
